/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import * as z from 'zod';
export const componentBrowserTypes = [
    'pv-module',
    'pv-inverter',
    'pv-cost-db',
    'battery',
    'ess-inverter',
    'mv-transformer',
    'bess-cost-db',
    'hv-cost-db',
    'h2-electrolyzer',
    'h2-liquefier',
    'thermal-generator',
    'weather',
    'met-station',
    'price-curve',
    'energy',
];
export const componentBrowserTypeSchemaZ = z.enum(componentBrowserTypes);
/** Which records a browse/search returns: active only (default), archived only, or both. */
export const componentArchivedFilters = ['exclude', 'only', 'include'];
const archivedFilterSchemaZ = z.enum(componentArchivedFilters).default('exclude');
export const componentBrowseQuerySchemaZ = z.strictObject({
    type: componentBrowserTypeSchemaZ,
    search: z.string().trim().optional(),
    offset: z.coerce.number().int().min(0).default(0),
    limit: z.coerce.number().int().min(1).max(500).default(100),
    archived: archivedFilterSchemaZ,
});
export const componentSearchQuerySchemaZ = z.strictObject({
    search: z.string().trim().min(1),
    types: z
        .string()
        .transform((value) => value.split(',').filter(Boolean))
        .pipe(z.array(componentBrowserTypeSchemaZ))
        .optional(),
    limit: z.coerce.number().int().min(1).max(50).default(10),
    archived: archivedFilterSchemaZ,
});
//# sourceMappingURL=component-browser.js.map